export default __webpack_public_path__ + "static/media/banner-seguro-loterico-desktop.3f80da8e.png";